import styled from 'styled-components';
import toRem from 'utils/toRem';
import handleNestedId from '../lib/handleNestedId.ts';
import InputLabel from '../partials/InputLabel/index.tsx';
import TextInputBase from '../partials/TextInputBase/index.tsx';
import Button from '../Button/index.tsx';
import InputError from '../partials/InputError/index.tsx';

export interface TextInputWithButtonProps {
  className?: string;
  type?: 'text' | 'email' | 'number' | 'password';
  id: string;
  label: string;
  description?: string;
  placeholder?: string;
  value?: string;
  hideControls?: boolean;
  buttonClassName?: string;
  buttonText: string;
  onChange?: () => void;
  onBlur?: () => void;
  onClick: () => void;
  disabled?: boolean;
  errors?: { [key: string]: { type: string; message: string } };
}

const StyledInputContainer = styled.div`
  display: inline-flex;
  gap: ${toRem(15)};
`;

const TextInputWithButton = ({
  className,
  type = 'text',
  id,
  label,
  description,
  placeholder,
  value,
  hideControls = false,
  buttonClassName,
  buttonText,
  onChange,
  onBlur,
  onClick,
  disabled,
  errors,
}: TextInputWithButtonProps) => {
  const fieldId = handleNestedId(id);
  const hasErrors = !!errors && !!Object.keys(errors).length;

  return (
    <div
      data-testid="text-input-with-button"
      className={`cef-ui-text-input-with-button${
        className ? ` ${className}` : ''
      }`}>
      <InputLabel id={id} label={label} description={description} />

      {!hideControls && (
        <>
          <StyledInputContainer>
            <TextInputBase
              type={type}
              id={id}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              disabled={disabled}
              hasErrors={hasErrors}
            />

            <Button
              className={buttonClassName || ''}
              handleClick={onClick}
              disabled={disabled}>
              {buttonText}
            </Button>
          </StyledInputContainer>

          {hasErrors && fieldId && errors[fieldId] && (
            <InputError errorMessage={errors[fieldId].message} />
          )}
        </>
      )}
    </div>
  );
};

export default TextInputWithButton;
